import { SaveButton, DeleteButton } from "react-admin";

import { ToolbarStyles } from "../../styles/commonStyles";

const CustomToolbar = ({ redirect, ...rest }) => (
  <ToolbarStyles {...rest}>
    <SaveButton type="button" redirect="list" />
    <DeleteButton redirect={redirect} />
  </ToolbarStyles>
);

export default CustomToolbar;
